import { LazyLoadImage } from "react-lazy-load-image-component";

import Price from "components/common/ui/Price/Price";
import { useRemoveGiftCertificateFromCartMutation } from "app/api/giftCertificate/giftCertificateApi";
import { updateCart } from "redux/cart/cartSlice";
import { useDispatch, useSelector } from "redux/hooks";
import { GiftCertificateItem } from "types/CartTypes";
import { StyledProductCard } from "../AccountOrder/AccountProduct";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import GiftCertificateImage from "assets/images/gift-certificate/Gift kartica v1.png";
import { aboveMedium } from "utilities/variables/media";

const Title = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0.75rem;
  color: #212529;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: flex-start;
  width: 100%;
`;

const PriceRow = styled.li`
  margin-top: 0.2rem;
  list-style: none;

  @media ${aboveMedium} {
    display: flex;
    justify-content: flex-end;
  }
`;

type Props = {
  item: GiftCertificateItem;
  isMiniBasket?: boolean;
};

const GiftCertificateCard = ({ item, isMiniBasket }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cartId = useSelector((state) => state.cart.cart?.id);
  const [removeGC] = useRemoveGiftCertificateFromCartMutation();

  const handleRemove = async () => {
    try {
      const updatedCart = await removeGC({ cartId: cartId!, itemId: item.id }).unwrap();
      dispatch(updateCart(updatedCart));
    } catch {
      // Backend returns 400 when removing the last item (cart is deleted by BC)
      dispatch(updateCart(undefined));
    }
  };

  return (
    <StyledProductCard className={isMiniBasket ? "is-mini-basket" : ""}>
      <div className="image-wrapper">
        <LazyLoadImage src={GiftCertificateImage} alt={t("giftCard.title") as string} />
      </div>
      <Details className="product-details">
        <Title>{t("giftCard.title")}</Title>
        <ul>
          <li>{t("giftCard.to")}: {item.recipient.name} ({item.recipient.email})</li>
          <li>{t("giftCard.from")}: {item.sender.name}</li>
{item.message && (
            <li>
              {t("giftCard.message")}:{" "}
              {item.message.length > 40
                ? `${item.message.slice(0, 40)}...`
                : item.message}
            </li>
          )}
        </ul>
        <PriceRow className="price-total">
          <Price price={item.amount} />
        </PriceRow>
        <span className="item-remove" style={{ alignSelf: "flex-end" }} onClick={handleRemove}>
          {t("remove")}
        </span>
      </Details>
    </StyledProductCard>
  );
};

export default GiftCertificateCard;
